import React, { useEffect, useState } from 'react';
import makeStyles from '@material-ui/core/styles/makeStyles';
import {
  PUserPageTitle,
  UserPageTitle,
} from 'src/features/user/common/UserPageTitle';
import { UserPageCard } from 'src/features/user/common/UserPageCard';
import { GuestMenuTabs } from './GuestMenuTabs';
import { useHistory, useLocation } from 'react-router';

const useStyles = makeStyles(() => ({
  tabsContainer: {
    margin: '20px 0',
  },
}));

type PGuestsLayout = Partial<PUserPageTitle>;

export const GuestsLayout: React.FC<PGuestsLayout> = (props) => {
  const { title = 'Guests' } = props;
  const { children } = props;
  const classes = useStyles();
  const [currentTab, setCurrentTab] = useState('');
  const location = useLocation();
  const history = useHistory();

  useEffect(() => {
    setCurrentTab(location.pathname);
  }, [location.pathname]);
  return (
    <UserPageCard>
      <UserPageTitle title={title} />

      <GuestMenuTabs
        className={classes.tabsContainer}
        onChange={(value) => history.push(String(value))}
        value={currentTab}
      />

      <div>{children}</div>
    </UserPageCard>
  );
};
